// import all need packages
import 'babel-polyfill'
import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import store from '@/store.js';
import router from '@/routes.js';
import App from '@/app.vue'
import i18n from '@config/i18n.js';
import moment from "moment";
import VueCarousel from 'vue-carousel';
import VueMomentJS from "vue-momentjs";
import ActionCable from 'actioncable'
import {DatePicker, TimePicker} from 'element-ui'
import ElementLocale from 'element-ui/lib/locale'

import 'noty/lib/noty.css';
import 'semantic-ui-css/semantic.min.css';
import 'element-ui/lib/theme-chalk/index.css';

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

ga('create', 'UA-79546588-10', 'auto');
ga('set', 'location', window.location.href);
ga('send', 'pageview');

// require all need packages
window.ENV = process.env;
window.axios = require('axios');
window.config = require('@config/config.js');
window.$ = window.jQuery = require('jquery');
require('./assets/javascripts/pace.js');
require('semantic-ui-css/semantic.min.js');
window.Noty = require('noty');
window._ = require('lodash');
window.RestUrl = require('./assets/javascripts/rest_url.js')

// Vue.js config
Vue.config.productionTip = true
Vue.config.debug = true;
Vue.config.devtools = true;
sync(store, router)
Vue.use(VueMomentJS, moment);
Vue.use(VueCarousel);
Vue.use(DatePicker);
ElementLocale.i18n((key, value) => i18n.t('ui.'+key, value))

const CONFIG = new config();
Vue.prototype.$cable = ActionCable.createConsumer(CONFIG.action_cable_url + '/cable');

window.object_to_query = function(obj, key = null) {
    var str = [];
    var sub_string, key_string = "";
    for(var p in obj)
        if (obj.hasOwnProperty(p)) {
            if (typeof obj[p] === 'object') {
                key_string = (!key) ? p : key+"["+p+"]";
                sub_string = object_to_query(obj[p], key_string);
                if (sub_string) {
                    str.push(sub_string)
                }
            } else {
                var main_key_sting = (key) ? key+"["+encodeURIComponent(p) + "]=" : encodeURIComponent(p) + "=" ;
                if (obj[p] != null && obj[p] !== "") {
                    str.push(main_key_sting + encodeURIComponent(obj[p]));
                }
            }

        }

    if (str.length) {
        return str.join("&");
    } else {
        return false
    }
}

window.object_delete_null = (obj) => {
    Object.keys(obj).forEach((key) => {
        if (obj[key] && typeof obj[key] === 'object') {
            object_delete_null(obj[key])
        }
        else if (obj[key] == null) {
            delete obj[key]
        }
    })

    Object.keys(obj).forEach((key) => {
        if (
            (
                Object.keys(obj[key]).length == 0 &&
                typeof obj[key] === 'object'
            ) || (
                obj[key] === ''
            )
        ) delete obj[key]
    })

    return obj
}

window.date_to_start = (date) => {
    return moment(date).startOf('day').format("YYYY-MM-DDTHH:mm:ss"+get_time_zone())
}

window.date_to_end = (date) => {
    return moment(date).endOf('day').format("YYYY-MM-DDTHH:mm:ss"+get_time_zone())
}

window.get_time_zone = () => {
    var locale = localStorage.language || "zh-tw";
    switch (locale) {
        case "zh-tw":
            return "+08:00"
            break
        default:
            return "+08:00"
    }
}

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
    // Noty
    Noty.overrideDefaults({
        layout: 'bottomRight',
        theme: 'semanticui',
        timeout: 1500,
        closeWith: ['click', 'button'],
        animation: {
            open: 'noty_effects_open',
            close: 'noty_effects_close'
        }
    });
    Vue.prototype.$noty = new Object;
    Vue.prototype.$noty.success = function(text, timeout = 1500){
        new Noty({
            type: 'success',
            text: text,
            timeout: timeout
        }).show();
    }
    Vue.prototype.$noty.error = function(text, timeout = 1500){
        new Noty({
            type: 'error',
            text: text,
            timeout: timeout
        }).show();
    }
    Vue.prototype.$noty.warning = function(text, timeout = 1500){
        new Noty({
            type: 'warning',
            text: text,
            timeout: timeout
        }).show();
    }
    Vue.prototype.$noty.information = function(text, timeout = 1500){
        new Noty({
            type: 'information',
            text: text,
            timeout: timeout
        }).show();
    }
    Vue.prototype.human_datetime = function(data, format="lll", type="absolute") {
        var locale = this.$store.state.language || "zh-tw";
        switch (data) {
            case "today":
                return moment().locale(locale).format(format);
                break;
            default:
                switch (type) {
                    case "absolute":
                        return moment(data).locale(locale).format(format);
                        break;
                    case "relative":
                        return moment(data).locale(locale).fromNow();
                        break;
                }
        }
    },
    Vue.prototype.$ = jQuery;
    Vue.prototype._ = _;

    // Vue.directive
    Vue.directive("font", {
        inserted: function(el) {
            setTimeout(function() {
                $(el).attr("style", "font-size: 10px !important");
            }, 300);
        }
    })

    Vue.directive("dropdown", {
        inserted: function(el) {
            if (!el.className.includes("no_search")) {
                $(el).addClass("search");
            }
            setTimeout(function() {
                $(el).dropdown();
            }, 300);
        }
    })

    Vue.directive("popup", {
        inserted: function(el) {
            setTimeout(function() {
                $(el).popup();
            }, 300);
        }
    })

    Vue.directive("tab", {
        inserted: function(el) {
            setTimeout(function() {
                $(el).tab();
            }, 300);
        }
    })

    Vue.directive("accordion", {
        inserted: function(el) {
            setTimeout(function() {
                $(el).accordion();
            }, 300);
        }
    })

    Vue.directive("checkbox", {
        inserted: function(el) {
            $(el).checkbox();
        }
    })

    Vue.directive("progress", {
        inserted: function(el) {
            setTimeout(function() {
                $(el).progress({
                    duration : 200,
                });
            }, 300);
        }
    })

    // Create a bus for global events
    var EventBus = new Vue()

    // vue properties
    Object.defineProperties(Vue.prototype, {
        $bus: {
            get: function () {
                return EventBus
            }
        }
    })

    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    }

    String.prototype.ljust = function( width, padding ) {
        padding = padding || " ";
        padding = padding.substr( 0, 1 );
        if( this.length < width )
            return this + padding.repeat( width - this.length );
        else
            return this;
    }
    String.prototype.rjust = function( width, padding ) {
        padding = padding || " ";
        padding = padding.substr( 0, 1 );
        if( this.length < width )
            return padding.repeat( width - this.length ) + this;
        else
            return this;
    }
    String.prototype.center = function( width, padding ) {
        padding = padding || " ";
        padding = padding.substr( 0, 1 );
        if( this.length < width ) {
            var len= width - this.length;
            var remain= ( len % 2 == 0 ) ? "" : padding;
            var pads= padding.repeat( parseInt( len / 2 ) );
            return pads + this + pads + remain;
        }
        else
            return this;
    }

    $(document).delegate('.identity', 'click', function(event) {
        var target_text = $(this).data('tooltip');
        $('.copy_textarea').remove();
        var temp_textarea = $("<textarea class='copy_textarea'>");
        temp_textarea.text(target_text).appendTo('body').select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            Vue.prototype.$noty.information('代碼(' + target_text + ')複製成功');
            temp_textarea.remove();
        } catch (err) {
            Vue.prototype.$noty.error('代碼複製失敗');
        }
    });

    document.getElementById('app-body').appendChild(document.createElement('app'))

    const app = new Vue({
        el: 'app',
        i18n: i18n,
        store: store,
        router: router,
        template: '<App/>',
        components: {
            App
        },
        watch: {
            '$route' (to, from) {
                ga('set', 'location', window.location.href);
                ga('send', 'pageview');
            }
        }
    })
})
